import _ from "lodash";
// import draftToHtml from "draftjs-to-html";
import { fetchApi } from "../../utils";

const mapField = data => {
  return {
    ...data,
    awards: _.map(_.get(data, "media_awards_data"), award => {
      return _.get(award, "full_file_path");
    }),
    reviews: _.get(data, "reviews")
  };
};

const fetchHomePageApi = () => {
  return fetchApi("page/home")
    .then(res => _.get(res, "data"))
    .then(mapField);
};

export { fetchHomePageApi };



// WEBPACK FOOTER //
// ./src/services/page/home.js